import { Icon, IconProps } from "./Icon";

export function IconHouserules(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M20.25 4.04 4 20.3l.7.71L20.97 4.75l-.7-.71ZM12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm0 23a11 11 0 1 1 0-22 11 11 0 0 1 0 22Z" />
    </Icon>
  );
}
